import { useEffect } from 'react'
import { MdErrorOutline } from 'react-icons/md'

export default function ErrorPage(){
  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })
  return(<>
  <div className="container mx-auto px-4">
  <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../Assets/slogan-white.png')}/>
      </div>
      <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] mx-auto flex flex-col justify-center items-center">
        <span className="text-[#F03623]"><MdErrorOutline size={150}/></span>
        <span>No se encontró la página</span>
      </div>
  </div>
  </>)
}